import React, { useEffect } from "react";
import { Box, Stack, Chip, Button, IconButton, Grid, Typography, useTheme, Tooltip, TextField, FormGroup, FormControlLabel, Switch } from "@mui/material";
import Diagram from "./components/diagram";
import MyResponsiveLineChart from "./components/diagram2";
import MyDottedLineChart from "./components/diagram3";
import MyDottedLineChart2 from "./components/diagram4";


//Hooks




//Controls


//Icons


const Prototype = () => {
    //const theme = useTheme();
    //const colors = tokens(theme.palette.mode);

    console.log("Prototype index");




    let content = <>


        <Diagram />
            <Box width="500px" height="500px"><MyResponsiveLineChart /></Box>
            <Box width="500px" height="500px"><MyDottedLineChart /></Box>
            <Box width="500px" height="500px"><MyDottedLineChart2 /></Box>


        <Box display="flex" width="100%" justifyContent="center">


          




        </Box>


    </>;

    return (
        <>
            {content}
        </>
    )
};

export default Prototype;

